export const SET_APPOINTMENT_SLOTS_LOADING = "SET_APPOINTMENT_SLOTS_LOADING";
export const SET_APPOINTMENT_EVENT_DETAILS = "SET_APPOINTMENT_EVENT_DETAILS"
export const GET_APPOINTMENT_EVENT_DETAILS_LOADING = "GET_APPOINTMENT_EVENT_DETAILS_LOADING"